import { makeAutoObservable, runInAction } from "mobx";
class SettingsStore {
  rootStore;
  anchorEl = null;
  // openMenu = false;
  commonDropDownMap = new Map([
    ['isOpenSettings', false],
    ['loadLimit', 10],
    ['tempLimit', 10],
    ['showLimitDropdown', false],
    ['popoverDelay', "0.1"],
    ['allowCellPopover', false],
    ['editDropdownVlaue', ""]
  ]);
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  get getIsOpenSettings() {
    return this.commonDropDownMap.get("isOpenSettings");
  }
  get getLoadLimit() {
    return this.commonDropDownMap.get("loadLimit");
  }
  get getTempLimit() {
    return this.commonDropDownMap.get("tempLimit");
  }
  get getShowLimitDropdown() {
    return this.commonDropDownMap.get("showLimitDropdown");
  }
  get getpopoverDelayValue() {
    return this.commonDropDownMap.get("popoverDelay");
  }
  get getallowCellPopoverValue() {
    return this.commonDropDownMap.get("allowCellPopover");
  }
  get editBoxValue() {
    return this.commonDropDownMap.get("editDropdownVlaue")
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonDropDownMap.set(key, value);
      }
    });
  }
  MenuOpen(event) {
    this.anchorEl = event.currentTarget;
  }
  closeMenu() {
    this.anchorEl = null;
    this.applyTheValue({ showLimitDropdown: false, editDropdownVlaue: "" })
  }
  // Toggles the 'showLimitDropdown' value
  toggleLimitDropdown() {
    const currentValue = this.getShowLimitDropdown;
    this.applyTheValue({ showLimitDropdown: !currentValue });
  }
  // Set temporary limit using the map
  setTempLimit(value) {
    this.applyTheValue({ tempLimit: value });
  }
  // Apply the limit after setting the temporary limit
  applyLimit() {
    const tempLimit = this.getTempLimit;  // Get the current tempLimit from the map
    this.applyTheValue({ loadLimit: tempLimit });  // Update loadLimit based on tempLimit
    this.closeMenu();
  }
}
export default SettingsStore;
